import { render, staticRenderFns } from "./index.vue?vue&type=template&id=68bc9aad&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=68bc9aad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bc9aad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68bc9aad')) {
      api.createRecord('68bc9aad', component.options)
    } else {
      api.reload('68bc9aad', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=68bc9aad&scoped=true&", function () {
      api.rerender('68bc9aad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/warehouses/index.vue"
export default component.exports